import FirebaseAdapter from "@wc/adapters/firebase";
import {
  PermissionsEnum,
  userHasPermissionInTeam,
  userHasPermissionInOrg,
} from "@wc/domain/authz";

/**
 * Update a team
 * @param {object} team The team with updated values
 * @param {object} user The user taking the action
 * @returns {Promise<void>}
 */
export async function updateTeam(team, user) {
  let hasPerm = false;
  try {
    // Check if user is TEAM_ADMIN (has EDIT_TEAM permission in team)
    const hasTeamPerm = await userHasPermissionInTeam(
      user,
      team.id,
      PermissionsEnum.EDIT_TEAM,
    );

    // Check if user is ORG_ADMIN (has MANAGE_TEAMS permission in org)
    const hasOrgPerm = await userHasPermissionInOrg(
      user,
      team.organizationId,
      PermissionsEnum.MANAGE_TEAMS,
    );

    hasPerm = hasTeamPerm || hasOrgPerm;
  } catch {
    throw new Error("Unable to update team");
  }

  if (!hasPerm) {
    throw new Error("Unable to update team");
  }

  await FirebaseAdapter().teams.saveTeam(team);
}
